import restApi from "@plannel/services/utils/rest-api";

/*
 * Supply Trend(선적·운송 성과) 데이터 서비스.
 * 독립 DW 기반 백엔드 조회 — 목업 없음, 전부 실데이터.
 *   백엔드: GET /api/dashboard-dw/supply-trend (SupplyTrendDashboardController)
 *   소스: z_fact_shipment_actual 단일 fact
 *   산식·설계 근거: saas-application/docs/sql/dw/dashboard-spec/08_supply_trend.md
 *
 * ★ 이 fact 는 DW 8 종 중 **유일하게 어느 대시보드도 안 쓰던** fact 다. 기존 화면들이 계획(DP/IP/MP/RP)과
 *   잔량(재고)만 보는 동안 **운송 구간**은 아무도 안 봤다 — mj 정시 도착률이 36.5% 다.
 *
 * 파라미터: { currentDate?, itemLevel? } — itemLevel 은 **품목 카드에만** 적용되는 계층 집계 레벨.
 *
 * 응답 envelope: { currencyCd, period, itemLevels[], itemLevel, itemGrouped,
 *                  kpis:{ onTime:{pct,arrived,ontime,deltaPct},
 *                         transit:{avgDays,deltaPct,plannedDays,gapDays,ratioPct},
 *                         inTransit:{shipments,qty,amt}, shipped:{qty,amt} },
 *                  delaySplit[{bucket,count,avgTransit,avgArrDelay}],
 *                  lanes[{origin,dest,shipments,avgTransit,onTimePct,avgArrDelay,
 *                         plannedLt,ltGap,ltRatio}],
 *                  items[{itemCd,itemName,shipments,onTimePct,avgTransit}],
 *                  inflight[{status,shipments,overdue,overduePct,avgOverdueDays,qty}],
 *                  trend[{period,onTimePct,avgTransit,shipments}] }
 *
 * ★ `inflight` 만 **아직 안 끝난 선적**(PLANNED/IN_TRANSIT)을 본다 — 다른 카드가 전부 지나간
 *   성적표인 것과 달리 "지금 손쓸 게 있다" 를 말하는 자리다. 역시 기간 필터가 없다.
 *
 * 🚨 성과 지표의 모수는 **ARRIVED 만**이다 — 아직 안 온 건은 "늦었다/제때다" 를 말할 수 없다.
 *    inTransit 만 IN_TRANSIT 를 따로 세고, **기간 필터가 없다**(지금 상태이지 기간 집계가 아니다).
 * 🚨 delaySplit.bucket 은 코드값(onTime/depRecovered/transitLate/bothLate) — 라벨은 프런트 i18n.
 */
const get = (params) => restApi.get("/api/dashboard-dw/supply-trend", { params });

const supplyTrendService = { get };

export default supplyTrendService;
